export default __webpack_public_path__ + "static/media/logo_sp.373e0f8f.png";